import React from 'react';
import PropTypes, { any } from 'prop-types';

import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { trackEvent } from '../../Analytics/TrackedClick';
import { PopupTypes } from '../../../utils/constants';
import * as popupActions from '../../../actions/popup-actions';
import { getClickAttrs } from '../../Analytics/gtag';
import Img from '../../Img';
import { PowerFunnelSurfaces, PowerFunnelGatedFeatures } from '../../Analytics/constants';

import styles from './powerPerksBanner.scss';

const PowerPerksBanner = ({ banner, history }) => {
    const auth = useSelector(({ auth }) => auth);
    const dispatch = useDispatch();
    const powerButtonText = auth.user?.hasPastDueSubscription ? 'Resume Power' : auth.user?.isPowered ? 'See All My Perks' : 'Start Power Now';

    const handlePowerClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (auth.user?.hasPastDueSubscription) {
            // segment call - mapped to GA4
            trackEvent(`Power Perks Hp Banner Resume Power Button ${banner.tracking_id} Click Segment`, {
                page: 'Home',
                button: 'Resume Power',
                action: 'click',
            });
            history.push('/subscriptions');
        } else if (auth.user?.isPowered) {
            // segment call - mapped to GA4
            trackEvent(`Power Perks Hp Banner Power Cta Button ${banner.tracking_id} Click Segment`, {
                page: 'Home',
                button: 'See All My Perks',
                action: 'click',
            });
            history.push('/power-perks?to=perks');
        } else {
            // segment call - mapped to GA4
            trackEvent(`Power Perks Hp Banner Start Power Button ${banner.tracking_id} Click Segment`, {
                page: 'Home',
                button: 'Start Power',
                action: 'click',
            });
            dispatch(popupActions.showPopupNew({
                popup: PopupTypes.POWER_UPGRADE_POPUP,
                referringSurface: PowerFunnelSurfaces.HOME,
                gatedFeature: PowerFunnelGatedFeatures.POWER_PERKS_BANNER,
                prismicTitle: banner?.text,
            }));
        }
    };

    const getPowerClickDataAttrs = () => {
        if (auth.user?.hasPastDueSubscription) {
            return {
                'data-context': `Power Perks Hp Banner Resume Power Button ${banner.tracking_id} Click`,
                'data-category': 'Resume Power',
                'data-location': 'Hp Banner Resume Power Button',
            };
        }
        if (auth.user?.isPowered) {
            return {
                'data-context': `Power Perks Hp Banner Power Cta Button ${banner.tracking_id} Click`,
                'data-category': 'Power Perks',
                'data-location': 'Hp Banner Power Cta Button',
            };
        }
        return {
            'data-context': `Power Perks Hp Banner Start Power Button ${banner.tracking_id} Click`,
            'data-category': 'Power Perks',
            'data-location': 'Hp Banner Start Power Button',
        };
    };

    const handlePerksClick = () => {
        trackEvent(`Power Perks Hp Banner Link ${banner.tracking_id} Click Segment`, {
            page: 'Home',
            button: 'See all power perks',
            action: 'click',
        });
        history.push('/power-perks');
    };

    return (
        <div className={styles.banner} data-testid={`banners.power-perks.banner-${banner.tracking_id}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12 d-block d-md-none">
                        <div className={styles.wrapper}>
                            <div className={styles.content}>
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-10 offset-1 text-center">
                                            <div className={`${styles.logo}`}>
                                                <Img src={banner.logo?.desktop?.default} style={{ height: banner.logo_height_mobile?.value || 'unset' }} data-testid="banners.power-perks.mobile-logo" />
                                            </div>
                                        </div>
                                        <div className={`col-10 offset-1 text-center`}>
                                            <div className={styles.text} data-testid="banners.power-perks.mobile-text">
                                                {banner.text}
                                            </div>
                                        </div>
                                        <div className={`${styles.ctaButton} col-10 offset-1 text-center`}>
                                            <div
                                                className="btn btn-primary text-uppercase"
                                                onClick={handlePowerClick}
                                                data-testid="banners.power-perks.mobile-cta-btn"
                                                {...getPowerClickDataAttrs()}
                                            >
                                                {powerButtonText}
                                            </div>
                                            {!auth.user?.isPowered && (
                                                <div
                                                    className="text-small clickable mt8"
                                                    onClick={handlePerksClick}
                                                    data-testid="banners.power-perks.mobile-perks-link"
                                                    {...getClickAttrs({
                                                        category: 'Power Perks',
                                                        context: `Power Perks Hp Banner Link ${banner.tracking_id} Click`,
                                                        location: 'Hp Banner Link',
                                                    })}
                                                >
                                                    See All Power Perks
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.bg}>
                            <Img src={banner.background_mobile?.desktop?.default} style={{ minHeight: '350px' }} />
                        </div>
                    </div>
                    <div className="col-12 d-none d-md-block">
                        <div className={styles.wrapper}>
                            <div className={styles.bg}>
                                <Img src={banner.background_desktop?.desktop?.default} />
                            </div>
                            <div className={styles.content}>
                                <div className="col-md-6 offset-md-6">
                                    <div className="col-md-10 offset-md-1 text-center p0">
                                        <div className={`${styles.logo} mb8`}>
                                            <Img src={banner.logo?.desktop?.default} style={{ height: banner.logo_height_desktop?.value || 'unset' }} data-testid="banners.power-perks.desktop-logo" />
                                        </div>
                                        <div className={styles.text} data-testid="banners.power-perks.desktop-text">
                                            {banner.text}
                                        </div>
                                        <div
                                            className="btn btn-primary text-uppercase"
                                            onClick={handlePowerClick}
                                            data-testid="banners.power-perks.desktop-cta-btn"
                                            {...getPowerClickDataAttrs()}
                                        >
                                            {powerButtonText}
                                        </div>
                                        {!auth.user?.isPowered && (
                                            <div className="text-small clickable mt4 cta-button" onClick={handlePerksClick} data-testid="banners.power-perks.desktop-perks-link">
                                                See All Power Perks
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(PowerPerksBanner);

PowerPerksBanner.propTypes = {
    history: PropTypes.objectOf(any),
    banner: PropTypes.objectOf(any),
};

PowerPerksBanner.defaultProps = {
    history: {},
    banner: {
        text: '',
        tracking_id: '',
        background_mobile: {
            desktop: {
                default: '',
            },
        },
        background_desktop: {
            desktop: {
                default: '',
            },
        },
        logo: {
            desktop: {
                default: '',
            },
        },
        logo_height_mobile: {
            value: '',
        },
    },
};
